import {COUNTRY,CANADA_COUNTRY} from "../helpers/variables";

export const PREMIUM_SETTING_COMMENT_AREA_INFO_MESSAGE = "Text in this field will only be viewable by ARAG users";
export const PREMIUM_SETTING_NOTES_AREA_INFO_MESSAGE = "Text in this field will appear in the policy schedule which is viewable by the solicitor users";

export const LOCAL_PHONE_NUMBER_ATE = COUNTRY == CANADA_COUNTRY ? '+1 416 342 5400' : '+44 117 917 1564';
export const LOCAL_EMAIL_ATE = COUNTRY == CANADA_COUNTRY ? 'ate@arag.ca' : 'ateunderwriting@arag.co.uk';


export const LAYOUT_FOOTER_TEXT_CA = 'ARAG Legal Solutions Inc. is authorized to operate in all Canadian provinces and territories, and is regulated by the relevant provincial or territorial insurance regulator, depending on where a policy is sold.';

// WI 99937: switch-OFF wording for the UK page footer - unchanged from before the WI, so an instance
// with the feature flag off (the default) keeps showing exactly what it showed previously. Mirrors
// EmailFooterResolver's switch-OFF behaviour for system emails (WI 99936).
export const LAYOUT_FOOTER_TEXT_UK = 'ARAG plc is authorised and regulated by the Financial Conduct Authority (FRN452369) <br /><br />Registered Office:<br />Unit 4a, Greenway Court, Bedwas, Caerphilly CF83 8DW<br />Registered in England & Wales.<br />Company Number 02585818';

// WI 99937: switch-ON wording - the ARAG legal-entity (LEI) details, shown when
// EmailFooterLegalEntityEnabled is on. Mirrors EmailFooterResolver's FOOTER_ADDRESS_LEI /
// FOOTER_AUTHORISATION_MESSAGE_LEI text for system emails (WI 99936).
export const LAYOUT_FOOTER_TEXT_UK_LEI = 'ARAG Legal Expenses Insurance Company Limited is authorised and regulated by the Financial Conduct Authority (FRN202106) <br /><br />Registered Office:<br />Unit 4a, Greenway Court, Bedwas, Caerphilly CF83 8DW<br />Registered in England & Wales.<br />Company Number 103274';

export const UK_ADDRESS_PART_1 = 'ARAG plc';
// Legal entity on a GPL policy's Advance Disbursements Statement - WI 100256. Only this line differs;
// the rest of the address is shared with ARAG plc.
export const UK_LEI_ADDRESS_PART_1 = 'ARAG Legal Expenses Insurance Company Limited';
export const UK_ADDRESS_PART_2 = 'Unit 4a, Greenway Court';
export const UK_ADDRESS_PART_3 = 'Bedwas, Caerphilly, CF83 8DW';
export const UK_ADDRESS_TEL = '0117 917 1680';

export const PRIVACY_URL = COUNTRY == CANADA_COUNTRY ? 'https://www.arag.ca/en/privacy-policy/' : 'https://www.arag.co.uk/cookie-policy';
export const WEBSITE_TERMS_OF_USE_URL = COUNTRY == CANADA_COUNTRY ? 'https://www.arag.ca/en/terms-of-use/' : 'https://www.arag.co.uk/data-legal/terms-conditions/';


export const X_URL = COUNTRY == CANADA_COUNTRY ? 'https://twitter.com/ARAG_ca' : 'https://twitter.com/ARAG_UK';
export const LINKEDIN_URL = COUNTRY == CANADA_COUNTRY ? 'https://ca.linkedin.com/company/arag-canada' : 'https://uk.linkedin.com/company/arag-legal-services-uk';
export const YOUTUBE_URL = COUNTRY == CANADA_COUNTRY ? 'https://www.youtube.com/channel/UCFfJpkKuFUJemCXX-Y2MYkQ' : 'https://www.youtube.com/channel/UC48LCy6-XbwODcGTm8MW52w';

export const POLICY_STATUS_MN_DRAFT = "Draft";
export const POLICY_STATUS_MN_LIVE = "Live";
export const POLICY_STATUS_MN_REFERRED = "Referred";
export const POLICY_STATUS_MN_REJECTED = "Rejected";
export const POLICY_STATUS_MN_CLOSED = "Closed";
export const POLICY_STATUS_MN_ABANDONED = "Abandoned";
export const POLICY_STATUS_MN_LOST = "Lost";
export const POLICY_STATUS_MN_WON = "Won";
export const POLICY_STATUS_MN_WON_RULE49 = "WonRule49";
export const POLICY_STATUS_MN_WON_WAIVER_LIMIT = "WonWaiverLimit";
export const POLICY_STATUS_MN_WON_LESS_PREMIUMPLUSDISB = "WonPremPlusDisb";
export const POLICY_STATUS_MN_ENTERED_IN_ERROR = "EnteredInError";
export const POLICY_STATUS_MN_FOURTEEN_DAY_COOLING_OFF_PERIOD = "FourteenDayCoolingOffPeriod";
export const POLICY_STATUS_MN_WON_PART36 = "WonPart36";
export const POLICY_STATUS_MN_FAILURE_TO_BEAT_LAST_OFFER = "FailureToBeatDefendantsLastFormalOffer";
export const POLICY_STATUS_MN_BELOW_THRESHOLD = "BelowThresholdNetFinancialRecovery";
export const POLICY_STATUS_MN_DISBURSEMENTS_EXCEED = "DisbursementsExceedFinancialRecovery";
export const POLICY_STATUS_MN_CLOSED_RA = "ClosedRA";
export const POLICY_STATUS_MN_CLOSED_TF = "ClosedTF";
export const POLICY_STATUS_MN_CLOSED_SC = "ClosedSC";
export const POLICY_STATUS_MN_DECLINED_BY_FIRM = "DeclinedByFirm";
export const POLICY_STATUS_MN_DECLINED_BY_ARAG = "DeclinedByArag";


export const SHOW_APPLICATION_PREMIUM_STATUSES = [
    POLICY_STATUS_MN_CLOSED,
    POLICY_STATUS_MN_LIVE,
    POLICY_STATUS_MN_ABANDONED,
    POLICY_STATUS_MN_WON,
    POLICY_STATUS_MN_WON_PART36,
    POLICY_STATUS_MN_LOST,
    POLICY_STATUS_MN_FAILURE_TO_BEAT_LAST_OFFER,
    POLICY_STATUS_MN_BELOW_THRESHOLD,
    POLICY_STATUS_MN_DISBURSEMENTS_EXCEED,
    POLICY_STATUS_MN_CLOSED_RA,
    POLICY_STATUS_MN_CLOSED_TF,
    POLICY_STATUS_MN_CLOSED_SC,
];

export const ALLOW_APP_FORM_EDIT_STATUSES = [
    POLICY_STATUS_MN_CLOSED,
    POLICY_STATUS_MN_LIVE,
    POLICY_STATUS_MN_ABANDONED,
    POLICY_STATUS_MN_WON,
    POLICY_STATUS_MN_WON_PART36,
    POLICY_STATUS_MN_LOST,
    POLICY_STATUS_MN_FAILURE_TO_BEAT_LAST_OFFER,
    POLICY_STATUS_MN_BELOW_THRESHOLD,
    POLICY_STATUS_MN_DISBURSEMENTS_EXCEED,
    POLICY_STATUS_MN_REFERRED,
    POLICY_STATUS_MN_CLOSED_RA,
    POLICY_STATUS_MN_CLOSED_TF,
    POLICY_STATUS_MN_CLOSED_SC,
];

// Event Names - aligned with backend ApplicationPolicyEvent class
export const EVENT_NAME_APPLICATION_FORM_CHANGED = "Application Form Changed";
export const EVENT_NAME_APPLICATION_FORM_CHANGE_APPROVED = "Application Form Change Approved";
export const EVENT_NAME_APPLICATION_FORM_CHANGE_REJECTED = "Application Form Change Rejected";
export const EVENT_NAME_APPLICATION_PREMIUM_SETTING_CHANGED = "Application Premium Setting Changed";
export const EVENT_NAME_DOCUMENT_RENAMED = "Document Renamed";
export const EVENT_NAME_PAYMENT_ALLOCATION = "Payment Allocation";

    
export const TAX = COUNTRY == CANADA_COUNTRY ? 'Sales Tax' : 'IPT';

export const POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL = "FeeEarnerEmail"
export const POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL_INTERNAL = "FeeEarnerEmailInternal"
export const POLICY_UPDATE_QUESTION_MN_LAWYERS_EMAIL_ADDRESS = "LawyersEmailAddress"
export const POLICY_UPDATE_OPT_MN_YES = "Yes";
export const POLICY_UPDATE_OPT_MN_CASE_TRANSFERRED = "CaseTransferred";
export const POLICY_UPDATE_OPT_MN_INTERNAL_TRANSFER = "InternalTransfer";

export const POLICY_UPDATE_QUESTION_CA_MN_HAS_LAWYER_CHANGED_SINCE_LAST_UPDATE = "HasLawyerChangedSinceLastUpdate";
export const POLICY_UPDATE_QUESTION_CA_MN_REASON_CASE_REPRESENTATION_CHANGED = "ReasonCaseRepresentationChanged";

export const CONFIRM_FEE_EARNER_CURRENTLY_RESPONSIBLE_MN = "ConfirmFeeEarnerCurrentlyResponsible";
export const FEE_EARNER_EMAIL_MN = "FeeEarnerEmail";
export const IS_CASE_CLOSED_MN = "IsCaseClosed";
export const CURRENT_LITIGATION_STAGE_MN = "CurrentLitigationStage";
export const OTHER_RESULT_INFO_MN = "OtherResultInfo";
export const HAS_LAWYER_CHANGED_SINCE_LAST_UPDATE_MN = "HasLawyerChangedSinceLastUpdate";
export const CONFIRM_DEFENDANTS_INSURERS_MN = "ConfirmDefendantsInsurers";
export const NAME_OF_INSURER_MN = "NameOfInsurer";

export const POLICY_SCHEDULE = COUNTRY == CANADA_COUNTRY ? 'Declaration' : 'Schedule';

export const OPPONENT_QUESTION_NAME_MAPPING = {
    'ProspectsAgainstOpponent': 'prospectsOptionId',
    'IsOpponentInsured': 'insuredOptionId',
    'WhoIsTheInsurer': 'insurerOptionId',
    'NameOfInsurerOther': 'otherInsurerName',
    'OpponentNotInsuredSatisfiedHasFunds': 'satisfiedOptionId',
    'OpponentDoNotKnowInsuredSatisfiedHasFunds': 'satisfiedOptionId',
    'OpponentName': 'name',
};

export const AMOUNT_TRIGGER_AREA_INFO_MESSAGE = "Referral trigger can be set using the comparator operators followed by an integer: <strong>></strong>, <strong><</strong> , <strong>>=</strong>, <strong><=</strong>. Referral trigger can also be set as a range using two integers separated by a hyphen: <strong>-</strong> .";
export const UPLOAD_FILE_POLICY_UPDATE_FORM_CA_TOOLTIP = "<style>body {max-height: 100vh;} ul ul {list-style-type: circle;margin-left: 20px;} ul ul ul {list-style-type: square;margin-left: 20px;} </style>\r\n<body>\r\n<strong>Transfer to new firm documents</strong>\r\n<ul>\r\n<li>• Letter to plaintiff confirming transfer; Notice of Change of Lawyer; Notice of Intention to Act in Person; and/or Order removing lawyer from record</li>\r\n</ul>\r\n<strong>Closure Documents</strong>\r\n<ul>\r\n<li>• Abandoned\r\n<ul>\r\n<li>If pleadings issued: Full & Final Release; and Dismissal Order/Discontinuance</li>\r\n<li>If pleadings not issued: Closing letter to plaintiff</li>\r\n</ul>\r\n</li>\r\n<li>• Below Threshold Net Financial Recovery or Disbursements Exceed Financial Recovery\r\n<ul>\r\n<li>Full & Final Release; Dismissal Order/Discontinuance; and Statement of Account</li>\r\n</ul>\r\n</li>\r\n</ul>\r\n</body>";

export const ABANDONED_POLICY_STATUSES = [
  POLICY_STATUS_MN_ABANDONED,
  POLICY_STATUS_MN_LOST,
  POLICY_STATUS_MN_CLOSED_RA,
  POLICY_STATUS_MN_CLOSED_TF,
  POLICY_STATUS_MN_CLOSED_SC,
];

// WI 97790: exactly the two statuses the story names. Deliberately NOT ABANDONED_POLICY_STATUSES above,
// which also carries the three CA-only Closed statuses and would widen the restriction silently.
export const CONTINGENT_EDIT_RESTRICTED_STATUSES = [
  POLICY_STATUS_MN_ABANDONED,
  POLICY_STATUS_MN_LOST,
];

// Application was turned down before going live (Rejected and the CA-only Declined statuses)
export const REJECTED_OR_DECLINED_STATUSES = [
    POLICY_STATUS_MN_REJECTED,
    POLICY_STATUS_MN_DECLINED_BY_FIRM,
    POLICY_STATUS_MN_DECLINED_BY_ARAG,
];

// Just the two CA-only Declined statuses — used to switch the modal reason field label
// between "Declined Reason" and "Rejected Reason".
export const DECLINED_POLICY_STATUSES = [
    POLICY_STATUS_MN_DECLINED_BY_FIRM,
    POLICY_STATUS_MN_DECLINED_BY_ARAG,
];
// Application is in a pre-live state (never been Live yet, or won't be)
export const PRE_LIVE_POLICY_STATUSES = [
    POLICY_STATUS_MN_DRAFT,
    POLICY_STATUS_MN_REFERRED,
    ...REJECTED_OR_DECLINED_STATUSES,
];

//TERMINAL POLICY STATUSES UK
export const TERMINAL_POLICY_STATUSES_UK = [ POLICY_STATUS_MN_WON, POLICY_STATUS_MN_WON_PART36, POLICY_STATUS_MN_ABANDONED, POLICY_STATUS_MN_LOST, POLICY_STATUS_MN_ENTERED_IN_ERROR];
//TERMINAL POLICY STATUSES CA
export const TERMINAL_POLICY_STATUSES_CA = [ POLICY_STATUS_MN_ABANDONED, POLICY_STATUS_MN_LOST,
    POLICY_STATUS_MN_WON, POLICY_STATUS_MN_BELOW_THRESHOLD,POLICY_STATUS_MN_DISBURSEMENTS_EXCEED, POLICY_STATUS_MN_FAILURE_TO_BEAT_LAST_OFFER,
    POLICY_STATUS_MN_CLOSED_RA, POLICY_STATUS_MN_CLOSED_TF, POLICY_STATUS_MN_CLOSED_SC];

// Compared against the API's machine-name field (`policyStatusMachineName`).
//DO NOT DISPLAY INCEPTION DATE FOR THESE POLICY STATUSES
export const DO_NOT_DISPLAY_INCEPTION_DATE_POLICY_STATUSES = [
    POLICY_STATUS_MN_DRAFT,
    POLICY_STATUS_MN_REFERRED,
    POLICY_STATUS_MN_REJECTED,
    POLICY_STATUS_MN_ENTERED_IN_ERROR,
    POLICY_STATUS_MN_FOURTEEN_DAY_COOLING_OFF_PERIOD,
    POLICY_STATUS_MN_DECLINED_BY_FIRM,
    POLICY_STATUS_MN_DECLINED_BY_ARAG,
];

export const DO_NOT_DISPLAY_POLICY_SCHEDULE_TAB_POLICY_STATUSES = [
    POLICY_STATUS_MN_DRAFT,
    POLICY_STATUS_MN_REFERRED,
    POLICY_STATUS_MN_REJECTED,
    POLICY_STATUS_MN_ENTERED_IN_ERROR,
    POLICY_STATUS_MN_FOURTEEN_DAY_COOLING_OFF_PERIOD,
    POLICY_STATUS_MN_DECLINED_BY_FIRM,
    POLICY_STATUS_MN_DECLINED_BY_ARAG,
];

//PREMIUM SETTINGS TYPES
export const PS_TYPE_CUSTOM = 'custom';
export const PS_TYPE_STAGED = 'staged';
export const PS_TYPE_PERCENTAGE = 'percentage';
export const PS_TYPE_DEFAULT = 'default';
// "Create New Based On Current": query-string key carrying the id of the source premium setting
// the new one is templated from, e.g. /premium-settings/new-premium-settings?copyFrom=97. Shared by
// every premium-setting type (flat/percentage via premiumSettingsWizardHOC, staged via
// stagedPremiumSettingsCreateHOC).
export const PREMIUM_SETTINGS_COPY_FROM_PARAM = 'copyFrom';
//TODO : this will be replaced in the future and the values will be taken from the API
export const PS_TYPE_PERCENTAGE_CASE_TYPES =  ['Clinical Negligence',];
export const ESTIMATED_LIABILITY_AND_CAUSATION_SPEND_MN = 'EstimatedLiabilityAndCausationSpend';
export const CLINICAL_NEGLIGENCE_MN = 'Clinical Negligence';

export const PROSPECTS_AGAINST_OPPONENT_MN = 'ProspectsAgainstOpponent';
export const IS_OPPONENT_INSURED_MN = 'IsOpponentInsured';
export const WHO_IS_THE_INSURER_MN = 'WhoIsTheInsurer';
export const NAME_OF_INSURER_OTHER_MN = 'NameOfInsurerOther';
export const OPPONENT_NOT_INSURED_SATISFIED_HAS_FUNDS_MN = 'OpponentNotInsuredSatisfiedHasFunds';
export const OPPONENT_DO_NOT_KNOW_INSURED_SATISFIED_HAS_FUNDS_MN = 'OpponentDoNotKnowInsuredSatisfiedHasFunds';
export const OPPONENT_NAME_MN = 'OpponentName';
export const ESTIMATED_MEDICAL_EXPERT_FEES_MN = 'EstimateForMedicalExpertFees';
export const SOLICITOR_REFERENCE_MN = 'solicitorReference';
export const DATE_OF_BIRTH_MN = 'dateOfBirth';
export const UPDATED_LNC_MN = 'UpdatedLnC';

// WI 95280: application questions frozen once a Premium Indemnity Guarantee has been applied.
// Mirrors AppConstants.PIG_LOCKED_QUESTION_MACHINE_NAMES in GatewayCore.DLL/Constants.cs.
export const PIG_LOCKED_QUESTION_MNS = [
    'CaseStage',
    'FastTrackDamages',
    'MultiTrackDamages',
    'SmallClaimsDamages',
    'IntermediateTrackDamages',
    'EstimatedLiabilityAndCausationSpend',
];

export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';
export const TERTIARY = 'tertiary';
export const QUATERNARY = 'quaternary';
export const DOWNLOAD = 'download';
export const PREVIEW = 'preview';
export const DOTS = 'dots';
export const PALE = 'pale';
export const LEFT = 'left';
export const RIGHT = 'right';
export const APPLICATION_MEDICAL_EXPERT_FEES = 'ApplicationMedicalExpertFees'
export const APPLICATION_OPPONENT = 'ApplicationOpponent';
export const DATE_FORMAT = ['dd/MM/yyyy', 'd/M/yy'];
export const MOMENT_DATE_FORMAT = 'DD/MM/YYYY';
export const MOMENT_DATE_TIME_FORMAT = 'DD/MM/YYYY - HH:mm:ss';
export const MOMENT_DATE_TIME_FORMAT_12_HOUR = 'DD/MM/YYYY, h:mm:ss a';
export const INITIAL_OPTIONS = [{ key: '', label: '' }];
export const INITIAL_NONE_OPTIONS = [{ key: '', value: '', label: 'None' }];
export const SUBMIT = 'submit';
export const BUTTON = 'button';
export const MOMENT_TIME_FORMAT = 'HH:mm:ss';
export const CIRCLE = 'circle';
export const REMOVE = 'remove';

export const ERROR = 'error';
export const INFO = 'info';
export const SUCCESS = 'success';
export const WARNING = 'warning';
export const SOLICITOR = 'Solicitor';
export const LARGE = 'large';
export const SMALL = 'small';
export const MEDIUM = 'medium';

export const RECOVERABLE = 'recoverable';
export const NON_RECOVERABLE = 'nonRecoverable';
export const PREMIUM = 'premium';
export const UNDERWRITER_RATE = 'underwriterRate';
export const UNDERWRITER_RATE_PERCENTAGE = 'underwriterRatePercentage';
export const COMMISSION = 'commission';
export const COMMISSION_PERCENTAGE = 'commissionPercentage';

// Premium settings "source" tracking — which sibling field (amount or percentage, or
// recoverable/non-recoverable) the user last typed directly; the other one is derived
// from it. Drives whether the editable table cell shows the raw typed string or the
// rounded-for-display derived value (see amountIsDerived in premiumSettingsFunctions.js).
export const UNDERWRITER_RATE_SOURCE = 'underwriterRateSource';
export const RECOVERABLE_SOURCE = 'recoverableSource';
export const COMMISSION_SOURCE = 'commissionSource';
export const SOURCE_AMOUNT = 'amount';
export const SOURCE_PERCENTAGE = 'percentage';
export const QUINARY = 'quinary';
export const HEADING_1 = 'h1';
export const HEADING_2 = 'h2';
export const HEADING_3 = 'h3';
export const HEADING_4 = 'h4';
export const WIZARD = 'wizard';
export const DEFAULT = 'default';
export const SELECTED_WORKSOURCE = 'selectedWorksource';
export const SELECTED_WORKSOURCE_NAME = 'selectedWorksourceName';
export const SELECTED_SUB_CASE_TYPE = 'selectedSubCaseType';
export const SELECTED_CASE_TYPE = 'selectedCaseType';
export const SELECTED_SOLICITOR_GROUP = 'selectedSolicitorGroup';
export const SOLICITOR_FIRM_ID_MN = 'solicitorFirmId';
export const INTERNAL_ALERT_TEXT_MN = 'internalAlertText';
export const VALID_FROM_MN = 'validFrom';
export const VALID_TO_MN = 'validTo';
export const DATE_FORMAT_DD_MM_YYYY = 'dd/MM/yyyy';

export const ALL_PREMIUM_SETTINGS_FOR_COMBINATION = 'allPremiumSettingsForCombination';
export const ALL_STAGED_PREMIUM_SETTING = 'allStagedPremiumSetting';
export const REVERSE = 'reverse';
export const CUSTOM = 'custom';
export const LABEL = 'label';
export const TYPE = 'type';
export const TOTAL = 'total';
export const AMOUNT = 'amount';
export const PAID = 'paid';
export const UNPAID_AMOUNT = 'unpaidAmount';
// WI 100878 AC5: Financial Position "Not Due" column - the row's not-yet-crystallised balance, sourced
// from the backend OwedRowDto.NotDue.
export const NOT_DUE = 'notDue';
// WI 100878 AC1/AC2: Current Premium Information grouping column - the "Premium" / "Agent Commission"
// heading that labels the block of rows to its right.
export const GROUP = 'group';

export const CONTINGENT = 'Contingent';
export const WRITEBACK = 'Writeback';
export const NON_CONTINGENT = 'NonContingent';

// WI 99823: the group's ARAG provider code, matching Seeder.cs's Arag_Provider_Code_PLC.
export const ARAG_PROVIDER_CODE_PLC = 'PLC';

export const PREMIUM_TYPE = {
    CONTINGENT: { key: CONTINGENT, label: 'Contingent' },
    NON_CONTINGENT: { key: NON_CONTINGENT, label: 'Non-Contingent' },
};

export const getPremiumTypeByKey = (key) => Object.values(PREMIUM_TYPE).find(t => t.key === key);
export const PERCENTAGE = 'percentage';
export const NOW = 'now';
export const YESTERDAY = 'yesterday';
export const TOMORROW = 'tomorrow';
export const ATTENDANCE_ESTIMATED_COST = 'AttendanceEstimatedCost';
export const BREACH_CAUSATION_CP_ID = 'BreachCausationCpId';
export const NAME = 'Name';
export const NATURE_OF_EXPERT = 'NatureOfExpert';
export const PARTIAL_ESTIMATED_COST = 'PartialEstimatedCost';
export const WHY_SPECIFIC_EXPERT = 'WhySpecificExpert';
export const CLIENT_NAME_MN = 'clientName';
export const ADDRESS_MN = 'address';
export const POST_CODE_MN = 'postCode';
export const WORK_SOURCE_ID_MN = 'workSourceId';
export const APPLICATION = 'Application';
export const DRAFT = 'Draft';
export const DOTTED = 'dotted';
export const SIZE_LG = 'lg';
export const SIZE_MD = 'md';
export const INSURED_OPTION_ID = 'insuredOptionId';
export const SATISFIED_OPTION_ID = 'satisfiedOptionId';
export const PROSPECTS_OPTION_ID = 'prospectsOptionId';
export const INSURER_OPTION_ID = 'insurerOptionId';
export const OTHER_INSURER_NAME = 'otherInsurerName';
export const ROW_INDEX = 'rowIndex';
export const BROKER = 'Broker';
export const HEADER = 'header';
export const REQUEST_UPDATE = 'RequestUpdate';
export const NAME_FIELD = 'name';
export const SEARCH = 'search';
export const NO_FILTER = 'noFilter';
export const INPUT_CHANGE = 'input-change';
export const NOT_AVAILABLE = 'N/A';

// EDITING SETTINGS COLUMNS
export const QUESTION = 'question';
export const EDITABLE_BY = 'editableBy';

export const LOCALE_UK = 'en-GB';

//Data test ids


//Application Premium Settings test ids
export const APPLICATION_PREMIUM_SETTINGS_LOI_TEST_ID = 'application-premium-settings-limit-of-indemnity';
export const APPLICATION_PREMIUM_SETTINGS_NOTES_TEST_ID = 'application-premium-settings-notes';
export const APPLICATION_PREMIUM_SETTINGS_COMMENTS_TEST_ID = 'application-premium-settings-comments';
export const APPLICATION_PREMIUM_SETTINGS_ENDORSEMENTS_TEST_ID = 'application-premium-settings-endorsements';
export const APPLICATION_PREMIUM_SETTINGS_TABLE_TEST_ID = 'application-premium-settings-table';
export const APPLICATION_PREMIUM_SETTINGS_COVERAGE_TEST_ID = 'application-premium-settings-coverage-types'
export const APPLICATION_PREMIUM_SETTINGS_DEDUCTIBLE_TEST_ID = 'application-premium-settings-deductibles'


//Premium Settings Wizard test ids
export const PREMIUM_SETTINGS_WIZARD_LOI_TEST_ID = 'premium-settings-wizard-limit-of-indemnity';
export const PREMIUM_SETTINGS_WIZARD_NOTES_TEST_ID = 'premium-settings-wizard-notes';
export const PREMIUM_SETTINGS_WIZARD_COMMENTS_TEST_ID = 'premium-settings-wizard-comments';
export const PREMIUM_SETTINGS_WIZARD_ENDORSEMENTS_TEST_ID = 'premium-settings-wizard-endorsements';
export const PREMIUM_SETTINGS_WIZARD_TABLE_TEST_ID = 'wizard-premium-settings-table';
export const PREMIUM_SETTINGS_WIZARD_DEDUCTIBLE_TEST_ID = 'premium-settings-wizard-deductibles'
export const PREMIUM_SETTINGS_WIZARD_COVERAGE_TEST_ID = 'premium-settings-wizard-coverage-types'
export const PREMIUM_SETTINGS_WIZARD_ENDORSEMENT_TEST_ID = 'premium-settings-wizard-endorsements'
export const EDIT_STAGED_APPLICATION_PREMIUM_SETTING_OVERVIEW_SUBMIT = 'edit-staged-application-premium-setting-overview-submit';
export const EDIT_STAGED_APPLICATION_PREMIUM_SETTING_NEXT_STEP = 'edit-staged-application-premium-setting-next-step';

//Premium Settings test ids
export const PREMIUM_SETTINGS_LOI_TEST_ID = 'premium-settings-setting-limit-of-indemnity';
export const PREMIUM_SETTINGS_NOTES_TEST_ID = 'premium-settings-setting-notes';
export const PREMIUM_SETTINGS_COMMENTS_TEST_ID = 'premium-settings-setting-comments';
export const PREMIUM_SETTINGS_ENDORSEMENTS_TEST_ID = 'premium-settings-setting-endorsements';
export const PREMIUM_SETTINGS_TABLE_TEST_ID = 'premium-settings-setting-table';
export const PREMIUM_SETTINGS_COVERAGE_TEST_ID = 'premium-settings-setting-coverage-types'
export const PREMIUM_SETTINGS_DEDUCTIBLE_TEST_ID = 'premium-settings-setting-deductibles'


//WORDING ERROR MESSAGE
export const WORDING_ERROR_MESSAGE = `Failed to retrieve policy wording. If this issue persists, please contact ARAG directly at ${LOCAL_PHONE_NUMBER_ATE} or ${LOCAL_EMAIL_ATE}`;

//Disbursements Excel File
export const DISBURSEMENTS_EXCEL_FILE_DOWNLOAD_BUTTON_LABEL = 'Export to Excel';
export const DISBURSEMENTS_EXCEL_FILE_DOWNLOAD_BUTTON_INFO = 'Download results as Excel (all filtered rows)';



//changeNewAppField codes
export const TRIGGERED_QUESTIONS_TO_DISPLAY = 'triggeredQuestionsToDisplay';
export const DELETE_MODAL_OPEN = 'deleteModalOpen';
export const UPDATING_QUESTION_ANSWER_FAIL = 'updatingQuestionAnswerFail';
export const FORM_DATA = 'formData';
export const FEATURED_QUESTIONS = 'featuredQuestions';
export const SHOW_FORM = 'showForm';
export const ID = 'id';
export const OPTIONS = 'options';
export const BAD_MSG = 'badMsg';
export const DUPLICATE = 'duplicate';
export const EXTRA_OPPONENTS = 'extraOpponents';
export const MED_EXPERT_FEES = 'medExpertFees';
export const NOT_VALID_MAIL = 'notValidMail';

//Notification type machine names
export const NOTIFICATION_TYPE_MN_UPDATED = 'Updated';
export const NOTIFICATION_TYPE_MN_UPDATE_REQUIRED = 'UpdateRequired';
export const NOTIFICATION_TYPE_MN_MORE_INFORMATION_REQUIRED = 'MoreInformationRequired';
export const NOTIFICATION_TYPE_MN_INFORMATION_PROVIDED = 'InformationProvided';
export const NOTIFICATION_TYPE_MN_DISBURSEMENT = 'Disbursement';
export const NOTIFICATION_TYPE_MN_APP_FORM_CHANGE_APPROVED = 'ApplicationFormChangeApproved';
export const NOTIFICATION_TYPE_MN_APP_FORM_CHANGE_REJECTED = 'ApplicationFormChangeRejected';
export const NOTIFICATION_TYPE_MN_REQUEST_FOR_APP_FORM_CHANGE = 'RequestForApplicationFormChange';
export const NOTIFICATION_TYPE_MN_APP_FORM_CHANGED = 'ApplicationFormChanged';
export const NOTIFICATION_TYPE_MN_UPDATE_COMPLETED_BY_ARAG = 'UpdateCompletedByARAG';
export const NOTIFICATION_TYPE_MN_COMMENT_NEW_APPLICATION = 'NewApplicationWasCreated';
export const NOTIFICATION_TYPE_MN_NO_CHANGES = 'NoChanges';

// Notification event types
export const NOTIFICATION_EVENT_STATUS_CHANGED = 'Status Changed';

//Referred Options
export const MEDICAL_EXPERT = 'Medical Expert';
export const TECHNICAL_UNDERWRITER = 'Technical Underwriter'; 
export const UNDERWRITER = 'Underwriter';

export const REFERRED_TO_OPTION = 'Referred to ';

export const REFERRED_KEY_MEDICAL_EXPERT_MN = 'ReferredToMedicalExpert';
export const REFERRED_KEY_TECHNICAL_UNDERWRITER_MN ='ReferredToTechnicalUnderwriter';
export const REFERRED_KEY_UNDERWRITER_MN = 'ReferredToUnderwriter';

export const REFERRED_OPTIONS = [
	{key: REFERRED_KEY_MEDICAL_EXPERT_MN, label: REFERRED_TO_OPTION+MEDICAL_EXPERT},
	{key: REFERRED_KEY_TECHNICAL_UNDERWRITER_MN, label: REFERRED_TO_OPTION+TECHNICAL_UNDERWRITER},
	{key: REFERRED_KEY_UNDERWRITER_MN, label: REFERRED_TO_OPTION+UNDERWRITER}
];
// Bare "Referred" plus the three referred-to-X dropdown options. The modal shows the
// Referred Reason field when the user picks any of these.
export const REFERRED_POLICY_STATUSES = [
    POLICY_STATUS_MN_REFERRED,
    REFERRED_KEY_MEDICAL_EXPERT_MN,
    REFERRED_KEY_TECHNICAL_UNDERWRITER_MN,
    REFERRED_KEY_UNDERWRITER_MN,
];

export const ENTER = 'Enter';


//URLS
export const PREMIUM_SETTINGS_URL = '/premium-settings';

//Href Constants
export const HREF_HOME = '/';
export const HREF_NEW_APPLICATION = '/new-application';
export const HREF_APPLICATION_AND_POLICIES = '/application-and-policies';
export const HREF_ADVANCE_DISBURSEMENTS = '/advance-disbursements';
export const HREF_NOTIFICATIONS = '/notifications';
export const HREF_NEW_USER = '/newUser';
export const HREF_USERS = '/users';
export const HREF_MANAGE_USER_ACCOUNT = '/manage-user-account';
export const HREF_MANAGE_ACCOUNT = '/manage-account';
export const HREF_EDITING_SETTINGS = '/editing-settings';
export const HREF_REFERRAL_SETTINGS = '/app-form-referral-settings';
export const HREF_ARTICLES = '/articles';
export const HREF_INTERNAL_ALERTS = '/internal-alerts';
export const HREF_SOLICITORS = '/solicitors';

//GLOBAL POLICY SEARCH
export const GLOBAL_POLICY_SEARCH_MIN_CHARACTERS = 5;

//ROLES
export const ROLE_SOLICITOR = 'Solicitor';
export const ROLE_USER = 'User';

//POLICY SOURCES
export const POLICY_SOURCE = {
	GATEWAY: 'Gateway',
	DISCUS: 'Discus',
};

export const formatGlobalSearchOptionLabel = (option) => (
	<span className="dot-search-suggestion">
		<span className={`policy-search-dot policy-search-dot--${option?.dotColor || ''}`} />
		{option?.label || ''}
	</span>
);

export const HIGHLIGHTED_FIELDS = 'highlightedFields';
export const EMPHASIZED_FIELDS = 'emphasizedFields';

// Active tab identifiers
export const TAB_APPLICATION = 'application';
export const TAB_OVERVIEW = 'overview';
export const TAB_DOCUMENTS = 'documents';
export const TAB_UPDATE = 'update';
export const TAB_POLICY_SCHEDULE = 'policySchedule';
export const TAB_ADVANCED_DISBURSEMENTS = 'advancedDisbursements';
export const TAB_PENDING_CHANGES = 'pendingChanges';
export const TAB_FINANCIALS = 'financials';

export const COSTS_SUMMARY_PAY_PREMIUM_TEXT = "Please ensure you pay the premium " + (COUNTRY == CANADA_COUNTRY ? '' : "and disbursement ") + "due";
export const PREMIUM_PAYABLE_EXCL_TAX_HEADER = 'Premium payable (excl. ' + TAX + ')';
export const TOTAL_PREMIUM_PAYABLE_INCL_TAX_HEADER = 'Total Premium payable (incl. ' + TAX + ')';

// Financials tab is disabled only for Draft/Referred regardless of Systems of Record.
export const DO_NOT_DISPLAY_FINANCIALS_TAB_POLICY_STATUSES = [
    POLICY_STATUS_MN_DRAFT,
    POLICY_STATUS_MN_REFERRED,
];

// Matches GatewayCore.DLL/Helpers/SystemsOfRecordIds.GatewayPlutusLawsys (SelectedApp.systemsOfRecordId) -
// the Financials tab only exists for policies on this System of Record. Compare on the GUID, not the
// display name, since the name is just a derived label (SystemsOfRecordIds.GetName) and isn't the identity.
// The comparison helper (isGatewayPlutusLawsys) lives in helpers/functions.js alongside the rest of this
// codebase's shared predicate/formatting functions, not here with the raw constants.

export const SYSTEM_OF_RECORD_GATEWAY_PLUTUS_LAWSYS = 'a1b2c3d4-0001-4a1b-8c2d-000000000002';
